import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { PrintGroupModel } from '../models/product.printgroup.model';
import { ProductCategoryService } from '../services/productcategory.service';
import { environment } from 'src/environments/environment';
import { SpinnerService } from '../services/spinner.service';


@Component({
  selector: 'app-printgroups',
  templateUrl: './printgroups.component.html',
  styleUrls: ['./printgroups.component.css']
})
export class PrintgroupsComponent implements OnInit {

  productSubCategoryid: string;
  public printGroups: PrintGroupModel[] = [];
  baseUrl = environment.baseUrl;
  displayName: string;
  
  constructor(private route: ActivatedRoute, private router: Router, private service: ProductCategoryService,
    private spinner: SpinnerService
  ) {

    this.productSubCategoryid = this.route.snapshot.params.id;
   // debugger
    this.displayName = decodeURI(this.route.snapshot.queryParams.name);

    

  }

  ngOnInit(): void {
    this.spinner.showSpinner();
    this.service.getPrintGroupsBySubCategoryId(this.productSubCategoryid)
      .subscribe(
        (data => {
          this.printGroups = data;
        //  console.log(this.printGroups);
        }),
        (error => {
          console.log(error);
        })
      );
    this.spinner.hideSpinner();
    
  }

  encodeContent = function(data){
    return encodeURIComponent(data);
  }

}
